import React from "react";
import TableBase from "./Base";

const CategoriesTable = ({
	scrollHeight,
	actionWidth,
	withAction,
	dataSource,
	...props
}) => {
	const COLUMNS = [
		{
			title: "Name",
			dataIndex: "name",
			width: 250,
			ellipsis: true,
		},
		{
			title: "Short Name",
			dataIndex: "short_name",
			width: 200,
			ellipsis: true,
		},
		{
			title: "Published",
			dataIndex: "published",
			width: 100,
			ellipsis: true,
			render(record) {
				return record === true ? "Yes" : "No";
			},
		},
	];

	if (withAction) {
		COLUMNS.push({
			key: "action",
			width: actionWidth || 100,
			fixed: "right",
			render(record) {
				return withAction(record);
			},
		});
	}

	if (scrollHeight) {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991, y: scrollHeight }}
				{...props}
			/>
		);
	} else {
		return (
			<TableBase
				dataSource={dataSource}
				columns={COLUMNS}
				scroll={{ x: 991 }}
				{...props}
			/>
		);
	}
};

export default CategoriesTable;
